export default "__VITE_ASSET__fI$$v1ZW__"